// extracted by mini-css-extract-plugin
export var readonly = "_iu-1";
export var star = "_iu-0";